import axios, { AxiosResponse } from 'axios';
import * as utils from '@/apis/apiUtils';
import { JohaisetsuMasterGetAllResponse } from '@/models/apis/johaisetsu/johaisetsuCommon';

export default {
  getAll(): Promise<AxiosResponse<JohaisetsuMasterGetAllResponse>> {
    return axios.get(utils.getApiUrl('/johaisetsu_masters'));
  },
};
